export enum SchoolYear {
    _2023_24 = 10,
    _2026_27 = 13
}
